import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ProjectSale } from './project-sale';

@JsonObject('model.project.CalendarEstimateSale')
export class CalendarEstimateSale extends AbstractModel {

    @JsonProperty(Number, 'amount')
  amount?: number;

  @JsonProperty(Number, 'count')
  count?: number;
}
